import { css } from 'styled-system/css';

export const inputFieldStyles = {
	inputContainer: css({
		display: 'flex',
		width: '100%',
		flexDirection: 'column',
		fontSize: '12px',
		fontWeight: 500,
		lineHeight: 1,
		justifyContent: 'flex-start',
		gap: '3px',
	}),
	inputLabel: css({
		display: 'flex',
		width: '100%',
		alignItems: 'center',
		fontWeight: 400,
		justifyContent: 'center',
		flexWrap: 'wrap',
	}),
	requiredMark: css({
		color: '#f00',
		textAlign: 'right',
		alignSelf: 'stretch',
		width: '7px',
		margin: 'auto 0',
	}),
	labelText: css({
		color: 'jupiter.grey.70',
		alignSelf: 'stretch',
		flex: 1,
		flexBasis: '0%',
		margin: 'auto 0',
	}),
	inputField: css({
		position: 'relative',
		alignItems: 'center',
		borderRadius: '6px',
		border: '1px solid',
		borderColor: 'jupiter.grey.40',
		bgColor: 'jupiter.grey.10',
		display: 'flex',
		minH: '36px',
		width: '100%',
		padding: '0 12px',
		gap: '3px',
		fontSize: '14px',
		color: 'jupiter.grey.80',
		lineHeight: 1,
		justifyContent: 'flex-start',
		flexWrap: 'wrap',

		'& .icon': {
			color: 'jupiter.grey.60',
			w: '18px',
			h: '18px'
		},

		_hover: {
			borderColor: 'jupiter.grey.60',
		},

		'&:focus-within': {
			borderColor: 'jupiter.grey.70!',
		},

		'&[data-focus="true"]': {
			borderColor: 'jupiter.grey.70!'
		},

		_groupSuccess: {
			borderColor: 'jupiter.success.100!'
		},

		_groupError: {
			borderColor: 'jupiter.error.100!'
		}
	}),
	inputFieldError: css({
		borderColor: 'jupiter.error.100',
	}),
	inputIcon: css({
		aspectRatio: 1,
		objectFit: 'contain',
		objectPosition: 'center',
		width: '18px',
		alignSelf: 'stretch',
		margin: 'auto 0',
	}),
	inputText: css({
		alignSelf: 'stretch',
		flex: 1,
		gap: '10px',
		margin: 'auto 0',
		lineHeight: '18px',
		h: '100%'
	}),
	inputHint: css({
		color: 'jupiter.grey.60',
		minH: '15px',
		fontSize: '12px',
		fontWeight: '500',

		_groupSuccess: {
			color: 'jupiter.success.100'
		},

		_groupError: {
			color: 'jupiter.error.100'
		}
	}),
	errorIcon: css({
		display: 'none',
		color: 'jupiter.error.100!',
		_groupError: {
			display: 'block',
		},
	}),
	successIcon: css({
		display: 'none',
		color: 'jupiter.success.100!',
		_groupSuccess: {
			display: 'block',
		},
	}),
	code: css({
		position: 'absolute',
		right: '31px',
		top: '5px',
		width: '38px',
		height: '24px',
		borderRadius: '3px',
		mr: '3px',
	}),
	reset: css({
		cursor: 'pointer',

		_active: {
			transition: 'transform 800ms linear',
			transform: 'rotate(360deg)',
		}
	}),
};
  
  